import { useRef } from "react";
import { FeatureColumn, type FeatureColumnData } from "./FeatureColumn";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const FEATURE_COLUMNS: FeatureColumnData[] = [
  {
    items: ["Multiple Dashboard Views", "Global and Project Directories", "Automated Notifications"],
  },
  {
    items: ["Chat Correspondence", "Document Repository", "Meeting Minutes"],
  },
  {
    items: ["Request for Approval", "RFIs and Submittals", "Schedule Tracking"],
  },
  {
    items: ["Detailed Reporting", "Open and Critical Item List", "Closeout Documentation"],
  },
];

export function FeatureGrid() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".square", stagger: 0.12 });

  return (
    <section
      ref={sectionRef}
      id="section-nine"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding">
        <div className="ninth-section">
          <div className="square-section">
            {FEATURE_COLUMNS.map((column, index) => (
              <FeatureColumn key={index} column={column} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
